/**
 * Different spacing of the form items.
 * @public
 * @since 2.0.0
 */
enum FormItemSpacing {
	/**
	 * Normal spacing (smaller vertical space between form items).
	 * @public
	 */
	Normal = "Normal",

	/**
	 * Large spacing (larger vertical space between form items).
	 * @public
	 */
	Large = "Large",
}

export default FormItemSpacing;
